import React from "react";
import { Card, Button, Form } from "react-bootstrap";
import { IconX, IconTrash } from "@tabler/icons-react";

const SelectedItemsSummary = ({
  selectedItems,
  onUpdateQuantity,
  onRemoveItem,
  onUpdateManualItemQuantity,
  onRemoveManualItem,
  onClearAll,
  onSubmit,
  loading,
  isFormValid,
}) => {
  return (
    <Card
      style={{
        position: "sticky",
        top: "20px",
        backgroundColor: "#f8fafc",
        borderColor: "#d8e2ef",
        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.06)",
      }}
    >
      <Card.Header
        style={{
          backgroundColor: "#eef6ff",
          borderBottom: "1px solid #d8e2ef",
        }}
      >
        <h5 style={{ margin: 0, fontWeight: "600", color: "#1f3b57" }}>Item Service Terpilih</h5>
      </Card.Header>
      <Card.Body>
        {selectedItems.length === 0 ? (
          <p
            style={{
              color: "#6b7280",
              textAlign: "center",
              padding: "32px 0",
              margin: 0,
            }}
          >
            Belum ada item yang dipilih
          </p>
        ) : (
          <div style={{ display: "grid", gap: "12px" }}>
            {selectedItems.map((item) => (
              <Card
                key={item.key || item.inventory_id}
                style={{ border: "1px solid #e5e7eb", backgroundColor: "#ffffff" }}
              >
                <Card.Body style={{ padding: "12px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <p
                        style={{
                          margin: "0 0 4px 0",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      >
                        {item.item_name}
                        {!item.inventory_id && (
                          <span
                            style={{
                              fontSize: "10px",
                              color: "#059669",
                              marginLeft: "8px",
                              backgroundColor: "#ecfdf5",
                              padding: "2px 6px",
                              borderRadius: "4px",
                            }}
                          >
                            Manual
                          </span>
                        )}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          color: "#6b7280",
                          fontSize: "12px",
                        }}
                      >
                        Unit: {item.unit}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Form.Control
                        type="number"
                        min="0.1"
                        step="0.1"
                        value={item.quantity}
                        onChange={(e) => {
                          const newQuantity = parseFloat(e.target.value) || 0.1;
                          if (item.inventory_id) {
                            onUpdateQuantity(item.inventory_id, newQuantity);
                          } else {
                            onUpdateManualItemQuantity(item.key, newQuantity);
                          }
                        }}
                        style={{ width: "80px" }}
                      />
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => {
                          if (item.inventory_id) {
                            onRemoveItem(item.inventory_id);
                          } else {
                            onRemoveManualItem(item.key);
                          }
                        }}
                      >
                        <IconX size={14} />
                      </Button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            ))}

            <hr style={{ margin: "16px 0", borderColor: "#e5e7eb" }} />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "600",
              }}
            >
              <span>Total Items:</span>
              <span>
                {selectedItems.reduce((sum, item) => sum + item.quantity, 0)}
              </span>
            </div>

            <div style={{ display: "grid", gap: "8px" }}>
              <Button
                variant="outline-danger"
                onClick={onClearAll}
                disabled={selectedItems.length === 0}
                style={{
                  width: "100%",
                  borderColor: "#dc2626",
                  color: "#dc2626",
                }}
              >
                <IconTrash size={16} style={{ marginRight: "8px" }} />
                Clear All Items
              </Button>

              <Button
                style={{
                  width: "100%",
                  backgroundColor: "#059669",
                  border: "none",
                }}
                onClick={onSubmit}
                disabled={!isFormValid || loading}
              >
                {loading ? "Menyimpan..." : "Simpan Service"}
              </Button>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default SelectedItemsSummary;
